import { Theme } from '@/theme';
import styled from 'styled-components';

const BUTTON_SIZE = 'clamp(40px, 8vmin, 40px)';

export default styled.button`
  background-color: ${Theme.color.orange};
  left: 15px;
  top: 40.4px;

  height: ${BUTTON_SIZE};
  width: ${BUTTON_SIZE};

  border-radius: 50%;
  position: fixed;
  display: flex;

  padding: 5px;
  z-index: 2;

  justify-content: center;
  align-items: center;

  svg {
    width: 10px;
    height: 10px;
  }
`;
